import { NewsRecord } from './NewsRecord';

export class NewsModel {
    id: number;
    title: string;
    newsRecords: NewsRecord[];
    position: number;
    visibility: number;
    type: number;
}




